import styled from 'styled-components'
import { H3, H5, Text } from '../../../../../../../../../../Styles/typography'
import { darkAccent } from '../../../../../../../../../../Styles/colors'

export const InfoEl = styled.div`
  margin-top: 2em;

  ${Text} {
    margin-bottom: 0.25em;
    text-transform: uppercase;
    color: ${darkAccent};
  }

  ${H3} {
    font-weight: bold;
  }

  .description {
    margin-top: 1em;
    line-height: 1.5;
  }

  ${H5} {
    margin-top: 2em;
  }
`
